export const enum attendanceConstants {
  markAttendanceRequest = "MARK_ATTENDANCE_REQUEST",
  markAttendanceSuccess = "MARK_ATTENDANCE_SUCCESS",
  markAttendanceFailure = "MARK_ATTENDANCE_FAILURE",
  
  getEventAttendanceRequest = "GET_EVENT_ATTENDANCE_REQUEST",
  getEventAttendanceSuccess = "GET_EVENT_ATTENDANCE_SUCCESS",
  getEventAttendanceFailure = "GET_EVENT_ATTENDANCE_FAILURE",
}
